<!--wyz修改过了-->
<template>
    <div class="m-auto-1200">
        <div class="m-portlet m-portlet--head-sm m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            记录新生信息
                        </h3>
                    </div>
                </div>
            </div>
            <vue-scroll :ops="$ops" :style="{'height':$store.state.config.clientHeight-96-61.59-53.8+'px'}">
                <div class="m-portlet__body">
                    <el-form ref="studentForm" label-position="left" :model="studentForm"
                             label-width="120px">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="姓名" prop="name" >
                                    <el-input v-model="studentForm.student.name" placeholder="请输入姓名" @blur="check_name()" style="width:200px"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="性别">
                                    <el-radio-group v-model="studentForm.student.gender_id" style="width:200px">
                                        <el-radio :label="1">男生</el-radio>
                                        <el-radio :label="2">女生</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item v-if="school_status" label="学校" prop="school">
                                    <el-select v-model="studentForm.educationalExperience.school_id"
                                               clearable
                                               filterable remote :remote-method="search_school"
                                               placeholder="关键字搜索学校"
                                               style="width:200px">
                                        <el-option
                                                v-for="item in schools"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                    <el-button size='small' @click="handleSchoolChange()">+</el-button>
                                </el-form-item>

                                <el-form-item v-else label="学校">
                                    <el-input style="width:200px"
                                              v-model="studentForm.educationalExperience.defined_school"
                                              placeholder="输入学校"

                                    ></el-input>
                                    <el-button size='small' @click="handleSchoolChange()">-</el-button>
                                </el-form-item>

                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="年级" prop="grade_id">
                                    <el-select
                                            v-model="studentForm.educationalExperience.grade_id"
                                            align="right"
                                            placeholder="在读年级"
                                            style="width:200px">
                                        <el-option
                                                v-for="item in grades"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="校内班级" prop="schoolClass_id">
                                    <el-select
                                            v-model="studentForm.educationalExperience.schoolClass_id"
                                            align="right"
                                            placeholder="在读班级"
                                            style="width:200px">
                                        <el-option
                                                v-for="item in this.schoolClasses"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="学生手机" prop="studentPhone" >
                                    <el-input v-model="studentForm.student.phone" placeholder="联系方式"
                                              @change="check_phone(studentForm.student.phone)"
                                              style="width:200px"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="生日">
                                    <el-date-picker
                                            style="width:200px"
                                            v-model="studentForm.student.birthday"
                                            type="date"
                                            placeholder="请选择学生生日"
                                            value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="所选科目">
                                    <el-select v-model="studentForm.subject_ids"
                                               multiple placeholder="请选择科目"
                                               style="width:200px">
                                        <el-option
                                                v-for="item in subjects"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">

                            <el-col :span="12">
                                <el-form-item label="QQ">
                                    <el-input v-model="studentForm.student.qq" placeholder="QQ"
                                              style="width:200px"
                                    ></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="班主任">
                                    <el-select v-model="studentForm.headTeacher_id"
                                               filterable placeholder="请选择班主任"
                                               style="width:200px">
                                        <el-option
                                                v-for="item in headTeachers"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <el-row :gutter="20">

                            <el-col :span="12">
                                <el-form-item label="是否入学测试">
                                    <el-radio-group v-model="studentForm.student.admission_text" style="width:200px">
                                        <el-radio :label="1">是</el-radio>
                                        <el-radio :label="2">否</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>

                        </el-row>
                        <div class="m-separator m-separator--space m-separator--dashed" ></div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="渠道">
                                    <el-select v-model="studentForm.promotion_channel_ids"
                                               multiple placeholder="请选择渠道"
                                               @change="check_promotion_channel()"
                                               style="width:200px">
                                        <el-option
                                                v-for="item in promotion_channels"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" v-if="studentForm.promotion_channel_ids.includes(1)">
                            <el-col :span="12">
                                <el-form-item label="推荐人姓名">
                                    <el-select v-model="studentForm.student.referrer_id"
                                               filterable remote :remote-method="search_student"
                                               style="width:200px">
                                        <el-option
                                                v-for="item in students"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="推荐人类型">
                                    <el-radio-group v-model="studentForm.student.referrer_type" style="width:200px">
                                        <el-radio-button label="家长"></el-radio-button>
                                        <el-radio-button label="学生"></el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" v-if="studentForm.promotion_channel_ids.includes(6)">
                            <el-col :span="12">
                                <el-form-item label="其他">
                                    <el-input v-model="studentForm.other_channel_remark" placeholder="请输入"  style="width:200px"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <div class="m-separator m-separator--space m-separator--dashed"></div>

                        <el-row :gutter="20" v-for="(parent, index) in studentForm.parents" :key="parent.key">
                            <el-col :span="12">
                                <el-form-item label="家长身份">
                                    <el-select v-model="parent.parent_identity" placeholder="请选择家长身份" style="width:200px">
                                        <el-option
                                                v-for="item in parent_identity"
                                                :key="item"
                                                :label="item"
                                                :value="item">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="家长姓名">
                                    <el-input v-model="parent.name" placeholder="请输入家长姓名" style="width:200px"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="家长电话" prop="parentPhone" >
                                    <el-input v-model="parent.phone" placeholder="联系方式" @change="check_phone(parent.phone)" style="width:200px"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item>
                                    <el-button v-if="index !== 0" @click="handleRemoveParent(parent)">删除该条</el-button>
                                    <el-button v-else @click="handleAddParent">新增家长</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </vue-scroll>
            <div class="m-portlet__foot">
                <div class="align-items-center">
                    <el-button @click="store_student" :loading="button_loading">确认注册</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "StudentRegister",
        data() {
            return {
                path: '/student/register',
                button_loading: false,

                //页面数据
                subjects: [],
                grades: [],
                showSubjects: [],
                schools: [],
                parent_identity: [],
                students: [],
                schoolClasses: [],
                headTeachers: [],
                promotion_channels:[],
                school_status: true,
                studentForm: {
                    student: {
                        avatar_url: "",
                        name: "",
                        phone: "",
                        address: "",
                        birthday: "2000-01-01",
                        gender_id: 1,
                        qq: "",
                        wechat: "",
                        admission_text: 2,
                        score: "",
                        referrer_id: "",
                        referrer_type: "",
                        referee_number: "",
                    },
                    educationalExperience: {
                        school_id: '',
                        grade_id: '',
                        schoolClass_id: '',
                        defined_school: ''
                    },
                    parents: [{
                        parent_identity: '',
                        name: '',
                        phone: ''
                    }],
                    headTeacher_id: '',
                    subject_ids: [],
                    promotion_channel_ids:[],
                    other_channel_remark:'',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入学生名称', trigger: 'blur'},
                        {min: 1, message: '请输入学生名称', trigger: 'blur'}
                    ],
                    school: [
                        {message: '请输入学校', trigger: 'blur'},
                        {min: 1, message: '请输入学校', trigger: 'blur'}
                    ],
                    gender_id: [{message: '请选择性别', trigger: 'blur'}],
                    grade_id: [{message: '请选择年级', trigger: 'blur'}],
                },
            }
        },
        created() {
            this.handleCreate();
            this.handleInit();
            this.search_school("");
            this.search_student("");
            this.search_headTeacher();
        },
        methods: {
            handleCreate() {
                //建立webSocket链接
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data, status) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.parent_identity = data.parent_identity;
                        this.subjects = data.subjects;
                        this.grades = data.grades;
                        this.schoolClasses = data.schoolClasses;
                        this.promotion_channels = data.promotion_channels;
                        this.headTeachers = data.headTeachers;
                        break;
                    case 'search_headTeacher':
                        this.headTeachers = data.headTeachers;
                        break;
                    case 'search_student':
                        this.students = data.students;
                        break;
                    case 'search_school':
                        this.schools = data.schools;
                        break;
                    case 'check_name':
                        if (data.checkResult) {
                            this.$confirm('该学生已存在，是否创建?', '提示', {
                                confirmButtonText: '继续创建',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {

                            }).catch(() => {
                                this.studentForm.student.name='';
                            });
                        }
                        break;
                    case 'store_student':
                        if (status === "error") {
                            this.button_loading = false;
                            return 0;
                        }

                        this.$store.dispatch('addView', {
                            'title': data.name,
                            'path': '/student/' + data.student_id,
                            'closable': true
                        });

                        this.router.push({path: '/student/' + data.student_id});

                        this.$store.dispatch('delView', {
                            'title': '新生报名',
                            'path': '/student/register',
                            'closable': true
                        });
                        this.studentForm= {
                            student: {
                                avatar_url: "",
                                name: "",
                                phone: "",
                                address: "",
                                birthday: "2000-01-01",
                                gender_id: 1,
                                qq: "",
                                wechat: "",
                                admission_text: 2,
                                score: "",
                                referrer_id: "",
                                referrer_type: "",
                                referee_number: "",
                            },
                            educationalExperience: {
                                school_id: '',
                                grade_id: '',
                                schoolClass_id: '',
                                defined_school: ''
                            },
                            parents: [{
                                parent_identity: '',
                                name: '',
                                phone: ''
                            }],
                            headTeacher_id: '',
                            subject_ids: [],
                            promotion_channel_ids:[],
                            other_channel_remark:'',
                        };
                        this.button_loading = false;
                        break;
                    case 'store_student_error':
                        this.button_loading = false;
                        break;
                }
            },

            handleInit() {
                this.$wApi.send(this.path, 'init');
            },

            search_headTeacher() {
                this.$wApi.send(this.path, 'search_headTeacher');
            },

            search_school(query) {
                this.$wApi.send(this.path, 'search_school', {
                    'schoolKeyName': query,
                });
            },

            search_student(query) {
                this.$wApi.send(this.path, 'search_student', {
                    'studentKeyName': query,
                });
            },

            store_student() {
                this.button_loading = true;
                this.$wApi.send(this.path, 'store_student',
                    this.studentForm
                );
            },

            handleSchoolChange() {
                this.school_status = !this.school_status
            },

            //region 家长控制
            handleAddParent() {
                this.studentForm.parents.push({
                    student_id: '',
                    identity: '',
                    name: '',
                    phone: '',
                    key: Date.now()
                });
            },

            handleRemoveParent(item) {
                if (this.studentForm.parents.length === 1)
                    return this.$message.error('至少存在一个家长信息');
                let Index = this.studentForm.parents.indexOf(item);
                if (Index !== -1) {
                    this.studentForm.parents.splice(Index, 1)
                }
            },
//endregion

            //学生姓名验证 虞
            check_name() {
                this.$wApi.send(this.path, 'check_name', {
                    'name': this.studentForm.student.name,
                });
            },

            check_phone(item) {
                if (item.length !== 11 ) {
                    this.$message({
                        showClose: true,
                        message: '请正确输入手机号',
                        type: 'warning'
                    });
                }
            },
            check_promotion_channel(){
                if(!this.studentForm.promotion_channel_ids.includes(1)){
                    this.studentForm.student.referrer_id='';
                    this.studentForm.student.referrer_type='';
                    this.studentForm.student.referee_number='';
                }
                if(!this.studentForm.promotion_channel_ids.includes(6)){
                    this.studentForm.other_channel_remark='';
                }
            }
        }
    }
</script>

<style scoped>
    .m-auto-1200 {
        width: 1200px;
        margin: 0 auto;
    }
</style>
